type MaintenancePageProps = Readonly<{
  onRetry: () => void;
  isRetrying: boolean;
}>;

export const MaintenancePagePlaceholder = ({ onRetry, isRetrying }: MaintenancePageProps) => {
  return (
    <div style={{ padding: '20px', textAlign: 'center', marginTop: '50px' }}>
      <h1>Service Temporarily Unavailable</h1>
      <p>We are performing scheduled maintenance and the app is temporarily unavailable.</p>
      <p>You can retry connecting below.</p>
      <button
        onClick={onRetry}
        disabled={isRetrying}
        style={{ marginTop: '20px', minWidth: '100px' }}
      >
        {isRetrying ? 'Checking...' : 'Retry Check'} {/* Show loading text */}
      </button>
    </div>
  );
};
